import { createRef, SyntheticEvent, useEffect, useMemo, useState } from "react"
import { useFilter } from "../../../../../../../hooks/filter";
import { FilterProps } from "../../../../../../../hooks/filter/typing";
import { removeAllReference } from "../../../../../../../utils/methods/removedReference";
import { Item } from "../../../../../../../utils/types/generals";
import { Roles, Types } from "../../../../../../../utils/enums";
import { getArea, getDepartments, getDivisions, getRoles, getStore, getUserTypes } from "../../../../../../../utils/methods/geServiceWithItemsFormat";
import { InputModel } from "../../../../../../../utils/types";
import { userGroupServiceFetch, userServiceFetch } from "../../../../../../../utils/constants/callService";
import { returnQuery } from "../../../../../../../utils/methods/returnQuery";
import { useTranslation } from "react-i18next";
import { RefTable } from "../../../../../../../components/table/types";
import { Box, Checkbox, Typography } from "@mui/material";
import { useStyles } from "../styles";
import { UsersAdded, UsersToAdd } from "../type";
import { searchInModeLower } from "../../../../../../../utils/validate/validate";
import { fortmatUserPermission } from "../../../../../../../service/userGroup/format";
import { updateUserPermission } from "../../../../../../../service/userGroup/body";


const formatFilter = {
    from: "start_date",
    to: 'end_date',
    status: "status_ids",
    role: "role_ids",
    stores: "store_ids",
    userType: "user_type_ids",
    area: "areas_ids",
    department: "departments_ids"
}

const useBody = ({ id }: { id: string | undefined }) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const [loadings, setLoadings] = useState({ search: false, load: false, table: false, submit: false, main: false })
    const [tabValue, setTabValue] = useState('1');
    const [allDepartments, setAllDepartments] = useState<Item[]>([])
    const [rowAdd, setRowAdd] = useState<UsersToAdd[]>([])
    const [rowAdded, setRowAdded] = useState<UsersAdded[]>([])
    const [rowAddedCopy, setRowAddedCopy] = useState<UsersAdded[]>([])
    const [snackbar, setSnackbar] = useState<{ open: boolean; type: Types; message: string }>({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })
    const [openModal, setOpenModal] = useState<{
        open: boolean
        title?: string
        description?: string
        cancel?: () => void
        confirm?: () => void
    }>()
    const [listDeleteUsers, setListDeleteUsers] = useState<number[]>([])
    const [allChecked, setAllChecked] = useState<{ applies: boolean, delete: boolean }>({ applies: false, delete: false })
    const refTable = createRef<RefTable>()
    const [input, setInput] = useState<{ [x: string]: InputModel }>({
        search: {
            label: 'general.search',
            translate: true,
            name: 'search',
            type: 'text',
            value: null,
        },
        role: {
            label: 'general.tags.role',
            translate: true,
            name: 'role',
            type: 'filter-select',
            items: [],
            value: null,
        },
        userType: {
            label: 'general.tags.userType',
            translate: true,
            name: 'userType',
            type: 'filter-select',
            items: [],
            value: null,
        }
    })
    const [inputCreate, setInputCreate] = useState({
        search: {
            label: 'general.searchUsers',
            translate: true,
            name: 'search',
            value: null,
        },
        from: {
            label: 'general.tags.from',
            translate: true,
            name: 'from',
            type: 'date',
            value: null,
            rest: {
                max: 'to',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6,
            },
        },
        to: {
            label: 'general.tags.to',
            translate: true,
            name: 'to',
            type: 'date',
            value: null,
            rest: {
                min: 'from',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6,
            },
        },
        role: {
            label: 'general.tags.role',
            translate: true,
            name: 'role',
            type: 'filter-select',
            items: [],
            value: null,
        },
        stores: {
            label: 'general.tags.store',
            translate: true,
            name: 'stores',
            type: 'filter-select',
            items: [],
            value: null,
        },
        division_ids: {
            label: 'general.tags.divisions',
            translate: true,
            name: 'division_ids',
            type: 'filter-select',
            items: [],
            value: null,
        },
        userType: {
            label: 'general.tags.userType',
            translate: true,
            name: 'userType',
            type: 'filter-select',
            items: [],
            value: null,
        },
        area: {
            label: 'general.tags.area',
            translate: true,
            name: 'area',
            type: 'filter-select',
            items: [],
            value: null,
        },
        department: {
            label: 'general.tags.department',
            translate: true,
            name: 'department',
            type: 'filter-select',
            items: [],
            value: null,
        },
    } as { [x: string]: InputModel })
    const columns = {
        columnMain: [
            {
                id: 'name',
                label: t('general.tags.users'),
                headerCell: styles?.header,
            },
            {
                id: 'area',
                label: t('general.tags.area'),
                headerCell: styles?.header,
            },
            {
                id: 'department',
                label: t('general.tags.department'),
                headerCell: styles?.header,
            },
            {
                id: 'userType',
                label: t('general.tags.userType'),
                headerCell: styles?.header,
            },
            {
                id: 'role',
                label: t('general.tags.role'),
                headerCell: styles?.header,
            },
            {
                id: 'applies',
                label: '',
                headerCell: styles?.header,
                column: () => {
                    return (
                        <Box sx={styles?.label}>
                            <Checkbox
                                onChange={(e, checked) => {
                                    e.stopPropagation()
                                    changePermissions({ id: 'all', permisson: 'applies', value: checked })
                                }}
                                checked={allChecked.applies}
                            />
                            <Typography>{t('general.permission_check.access')}</Typography>
                        </Box>
                    )
                },
                renderCell: (params: any) => {
                    return (
                        <Checkbox
                            checked={!!params?.row?.applies}
                            onChange={(e, checked) => {
                                e.stopPropagation()
                                if (params?.row?.id) {
                                    changePermissions({ id: Number(params?.row?.id), permisson: 'applies', value: checked })
                                }
                            }}
                        />)
                }
            },
            {
                id: 'delete',
                label: '',
                headerCell: styles?.header,
                column: () => {
                    return (
                        <Box sx={styles?.label}>
                            <Checkbox
                                onChange={(e, checked) => {
                                    e.stopPropagation()
                                    changePermissions({ id: 'all', permisson: 'delete', value: checked })
                                }}
                                checked={allChecked.delete}
                            />
                            <Typography>{t('general.tags.delete')}</Typography>
                        </Box>
                    )
                },
                renderCell: (params: any) => {
                    return (
                        <Checkbox
                            checked={!!listDeleteUsers.find(item => item == params?.row?.id)}
                            onChange={(e, checked) => {
                                e.stopPropagation()
                                if (params?.row?.id) {
                                    changePermissions({ id: Number(params?.row?.id), permisson: 'delete', value: checked })
                                }
                            }}
                        />)
                }
            },
        ],
    }

    const changePermissions = ({ id, permisson, value }: { id: string | number, permisson: string, value: boolean }) => {
        if (id == 'all') {
            if (!!rowAddedFiltered.length) {
                if (permisson == 'delete') {
                    if (value) {
                        const newListDeleteUsers = rowAddedFiltered.map(item => item.id)
                        setListDeleteUsers(newListDeleteUsers)
                    } else {
                        setListDeleteUsers([])
                    }
                } else {
                    setRowAdded(prev =>
                        prev.map(item => {
                            const existsInFiltered = rowAddedFiltered.some(f => f.id === item.id);
                            return existsInFiltered
                                ? { ...item, applies: value }
                                : item;
                        })
                    );
                }
                setAllChecked(prev => ({ ...prev, [permisson]: value }))
            }
        } else {
            if (permisson == 'delete') {
                if (value) {
                    setListDeleteUsers(prev =>
                        prev.includes(Number(id)) ? prev : [...prev, Number(id)]
                    );
                } else {
                    setListDeleteUsers(listDeleteUsers.filter((item) => item !== Number(id)))
                }
            } else {
                setRowAdded(prev =>
                    prev.map(item =>
                        item.id === Number(id)
                            ? { ...item, applies: value }
                            : item
                    )
                );
            }
        }
    }

    const validateAllUsersAreSelected = () => {

        const usersId = rowAddedFiltered.map(item => item.id)
        const areThereAmyUserAplly = rowAddedFiltered.length > 0 ? rowAddedFiltered.every(item => item.applies === true) : false;
        const areThereAmyUserDelete = listDeleteUsers.length > 0 ? usersId.every(num => listDeleteUsers.includes(num)) : false;

        setAllChecked({ applies: areThereAmyUserAplly, delete: areThereAmyUserDelete })
    }

    const handleDelete = () => {
        setOpenModal(prev => ({
            ...prev,
            open: true,
            title: t("general.messages.sureWantDeleteTheUser"),
            description: t("general.messages.loseThePermissions"),
            confirm: () => {
                setOpenModal(prev => ({ ...prev, open: false }))
                removeUserSelecteds()
            },
            cancel: () => { setOpenModal(prev => ({ ...prev, open: false })) }
        }))
    }

    const removeUserSelecteds = () => {

        const filtered = rowAddedFiltered.filter(item => !listDeleteUsers.includes(item.id));
        setRowAdded(filtered)

        setListDeleteUsers([])
    }

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
    };

    const cancelSearchUsers = () => {
        createFilter.cleanFilter()
        setRowAdd([])
        setLoadings(prev => ({ ...prev, search: false }))
    }

    const handleAddUsers = ({ usersToAdd }: { usersToAdd: UsersAdded[] }) => {
        setRowAdded(prev => [...prev, ...usersToAdd]);
    }

    const searchUsers = async () => {
        try {
            setLoadings(prev => ({ ...prev, search: true }))
            const response = await userServiceFetch.filterUsers({ query: `status_ids=1&${returnQuery(createFilter.query, {})}` })
            let allUsers: { id: number; name: string; area: string; department: string; userType: string; role: string; }[] = response?.map(item => ({
                id: item.id,
                name: item.fullName,
                area: item.area,
                department: item.department,
                userType: item.userType,
                role: item.role
            })) ?? []

            if (!!allUsers?.length) {
                setRowAdd(allUsers)
            } else {
                setRowAdd([])
                setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
            }
        } catch (e) {
            setRowAdd([])
            setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
        }
        finally {
            setLoadings(prev => ({ ...prev, search: false }))
        }
    }

    const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'area') {
            const { area, department } = copyBody
            const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
            let arrayChilds: any[] = []

            area?.forEach((e: any) => {
                const id = e.value
                const childs = allDepartments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })

            setFilterData((prev) => ({
                ...prev,
                department: newDepartments,
            }))

            setInputCreate(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
            copyBody = {
                ...copyBody,
                department: newDepartments,
            }
        }

        return copyBody
    }

    const getUserList = async () => {
        setLoadings(prev => ({ ...prev, main: true }))
        if (id) {
            const response = await userGroupServiceFetch.getUsersPermission(Number(id))
            const { row } = fortmatUserPermission({ response })
            setRowAdded(row)
            setRowAddedCopy(row)
        }

        setAllChecked({ applies: true, delete: false })
        setLoadings(prev => ({ ...prev, main: false }))
    }

    const submit = async () => {
        setOpenModal(prev => ({
            ...prev,
            open: true,
            title: t("userGroup.modal.titles.areYouSureAsignThisPermission"),
            description: '',
            confirm: () => {
                setOpenModal(prev => ({ ...prev, open: false }))
                confirmAubmit()
            },
            cancel: () => { setOpenModal(prev => ({ ...prev, open: false })) }
        }))
    }

    const confirmAubmit = async () => {
        setLoadings(prev => ({ ...prev, submit: true }))
        if (id) {
            const { body } = updateUserPermission({ rowAdded, rowAddedCopy, id })
            const response = await userGroupServiceFetch.updateUsersPermission(body)

            if (!response.errors && response.code == '00') {
                setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.updatePermision.success"), type: Types.SUCCESS }))
                getUserList()
            } else {
                setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.updatePermision.error"), type: Types.ERROR }))
            }

        }
        setLoadings(prev => ({ ...prev, submit: false }))
    }

    const createFilter = useFilter({
        formatFilter,
        externalValidation,
        defaultPagination: { pageSize: 500 }
    })

    const filter = useFilter({
        formatFilter,
    })

    const rowAddedFiltered = useMemo(() => {
        const formatRowPermissions = rowAdded?.filter(
            (itemUsers) =>
                (filter.filterData?.role instanceof Array ? (filter.filterData?.role.length > 0 ? filter.filterData?.role?.find((e: any) => e?.label === itemUsers?.role) : true) : true) &&
                (filter.filterData?.userType instanceof Array ? (filter.filterData?.userType?.length > 0 ? filter.filterData?.userType?.find((e: any) => e?.label === itemUsers?.userType) : true) : true) &&
                (filter.filterData?.search
                    ? searchInModeLower(`${itemUsers?.role} ${itemUsers?.userType} ${itemUsers.name}`, filter.filterData.search)
                    : true)
        ) ?? []

        return formatRowPermissions
    }, [rowAdded, filter.filterData])

    const getAllUnits = async () => {
        const { items } = await getStore()
        setInputCreate(prev => ({ ...prev, stores: { ...prev.stores, items } }))
    }

    const getAllUserTypes = async () => {
        const { items } = await getUserTypes()
        setInputCreate(prev => ({ ...prev, userType: { ...prev.userType, items } }))
        setInput(prev => ({
            ...prev,
            userType: {
                ...prev.userType,
                items: items ?? [],
            },
        }))
    }

    const getAllRoles = async () => {
        const { items } = await getRoles({ skip: [Roles.ADMIN] })

        setInputCreate(prev => ({ ...prev, role: { ...prev.role, items } }))

        setInput(prev => ({
            ...prev,
            role: {
                ...prev.role,
                items: items ?? [],
            },
        }))
    }

    const getAlDivisions = async () => {
        const { items } = await getDivisions()
        setInputCreate(prev => ({ ...prev, division_ids: { ...prev.division_ids, items } }))
    }

    const getAllAreas = async () => {
        const items = await getArea()
        setInputCreate(prev => ({ ...prev, area: { ...prev.area, items: items } }))
    }

    const getAllDepartments = async () => {
        const items = await getDepartments()
        setAllDepartments(items)
    }

    const getData = () => {
        getAllUnits()
        getAllUserTypes()
        getAllRoles()
        getAllAreas()
        getAllDepartments()
        getAlDivisions()
    }

    const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        getUserList()
    }, [id])

    useEffect(() => {
        validateAllUsersAreSelected()
    }, [rowAdded, listDeleteUsers, rowAddedFiltered])

    return {
        loadings,
        tabValue,
        handleChange,
        createFilter,
        input,
        inputCreate,
        cancelSearchUsers,
        snackbar,
        closeSnackbar,
        searchUsers,
        rowAdd,
        listDeleteUsers,
        refTable,
        columns,
        rowAdded,
        handleAddUsers,
        filter,
        openModal,
        handleDelete,
        rowAddedFiltered,
        submit
    }
}

export { useBody }
